// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header[data-v-33d0017c]{position:relative;width:100%;height:58px;display:flex;align-items:center;justify-content:space-between;padding:0 20px;background-color:#fff;border-radius:3px;margin-bottom:20px}.title[data-v-33d0017c]{color:#0f2345;font-size:1.42857rem;font-weight:700}.buttons[data-v-33d0017c]{display:flex}.btn_theme-create[data-v-33d0017c]{min-width:130px;font-weight:600;font-size:1rem;line-height:1.21429rem;padding-right:10px;padding-left:15px}", ""]);
// Exports
module.exports = exports;
